import React, { useState, useRef } from "react";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { EVENT_SCHEDULE } from "./constants";

const EventSchedule = () => {
  const [openAccordion, setOpenAccordion] = useState(0); // First item open by default
  const scheduleItemsRef = useRef([]);
  const linesRef = useRef([]);
  const containerRef = useRef(null);

  const toggleAccordion = (index) => {
    setOpenAccordion(index);
  };

  // GSAP animations
  useGSAP(() => {
    // Reset and clear previous animations
    gsap.killTweensOf(scheduleItemsRef.current);
    gsap.killTweensOf(linesRef.current);

    // Set initial states
    gsap.set(scheduleItemsRef.current, {
      y: 30,
      opacity: 0,
    });
    gsap.set(linesRef.current, {
      scaleX: 0,
      transformOrigin: "left center",
    });

    // Animate schedule items up with stagger
    gsap.to(scheduleItemsRef.current, {
      y: 0,
      opacity: 1,
      duration: 0.6,
      ease: "power2.out",
      stagger: 0.1,
    });

    // Animate lines expanding from left to right
    gsap.to(linesRef.current, {
      scaleX: 1,
      duration: 0.8,
      ease: "power2.out",
      stagger: 0.05,
      delay: 0.2,
    });
  }, [openAccordion]);

  return (
    <section className=" flex flex-col bg-[#F9F9F9]">
      <div className="container mx-auto px-4 py-16 md:px-10 lg:py-[100px] font-sora">
        <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-8 lg:mb-14 uppercase">
          Event Schedule
        </h2>
        <div className="flex flex-col md:flex-row md:gap-6 lg:gap-20   ">
          {/* Left side - Image */}
          <div className=" flex  md:flex-col gap-3">
            {EVENT_SCHEDULE.map((section, index) => (
              <div
                key={index}
                className={`w-full   py-4 text-center md:text-left md:p-5 border text-[#11302D] text-xl font-semibold cursor-pointer  ${
                  openAccordion === index
                    ? "border-[#304602] bg-[#CBF07F] "
                    : "border-black/20"
                }`}
                onClick={() => toggleAccordion(index)}
              >
                <p className="text-sm md:text-base lg:text-xl font-semibold text-[#11302D] font-inter whitespace-nowrap">
                  {section.label}{" "}
                  <span className="hidden lg:inline-block"> Session</span>
                </p>
              </div>
            ))}
          </div>
          {/* Right side - Accordion */}
          <div
            ref={containerRef}
            className="  space-y-6 mt-6 md:mt-0  pl-6 md:pl-10 lg:pl-20 border-l-[4px] border-l-[#1A1A1A] border-opacity-10"
          >
            {EVENT_SCHEDULE[openAccordion].value.map((item, idx, arr) => (
              <React.Fragment key={idx}>
                <div
                  ref={(el) => {
                    if (el) linesRef.current[idx * 2] = el;
                  }}
                  className="h-[1px] bg-[#11302D] opacity-20"
                />
                <div
                  ref={(el) => {
                    if (el) scheduleItemsRef.current[idx] = el;
                  }}
                  className=" text-gray-600 font-inter flex gap-4 items-start"
                >
                  <div className="mt-2 h-2.5 w-2.5 bg-[#A5D246] rounded-full" />

                  <div className="flex flex-col md:flex-row md:gap-4 ">
                    <p className="font-inter font-semibold text-[#1A1A1A] text-base lg:text-lg whitespace-nowrap">
                      {item.slot}
                    </p>
                    <p className="font-inter font-sembold text-[24] hidden md:block">
                      -
                    </p>
                    <p
                      className="font-inter  text-[#1A1A1A] italic text-base lg:text-lg max-w-sm"
                      style={{ textWrap: "balance" }}
                    >
                      {item.activity}
                    </p>
                  </div>
                </div>
                {idx === arr.length - 1 && (
                  <div
                    ref={(el) => {
                      if (el) linesRef.current[idx * 2 + 1] = el;
                    }}
                    className="h-[1px] bg-[#11302D] opacity-20"
                  />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventSchedule;
